<template>
    <main v-bind:class="{'main__login':auth}" >
        <div v-if="auth" class="container">
            <div class="main-check-ul">
                <h2>Проверка ЮЛ / ИП</h2>
                <div class="main-check-ul__search">
                    <input v-if="hasAccessToUlCheck" @keydown.40="arrowHandler" @keydown.38="arrowHandler" @keydown.13="openSelected" @input="timeoutRequest" v-model.trim="input" type="text" placeholder="ЮРЛ Леонид Грозный, Риск ИКС, ООО «Новострой» Гарматная ул...">
                    <input v-else type="text" placeholder="ЮРЛ Леонид Грозный, Риск ИКС, ООО «Новострой» Гарматная ул..." disabled>
                    <button v-if="hasAccessToUlCheck" @click="findHandler">НАЙТИ</button>
                    <button v-else style="cursor: not-allowed">НАЙТИ</button>

                    <span v-if="input" @click="resetSearch" class="lnr lnr-cross"></span>
                </div>
                <div v-if="searchLength" class="main-check-ul__search-results">
                    <div v-for="(e,i) in search" :key="i" @click="clickSearchItem(e.ogrn)" ref="search-items" :data-ogrn="e.ogrn">
                        <span>{{e.value}}</span>
                        <div v-if="e.management" class="fz12">
                            <b>{{e.management.post}}: </b>
                            <span>{{e.management.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-separator"></div>
            <div class="main-check">
                <!-- <a :href="hasAccessToFlCheck ? '/fl-check' : '#'" :class="{ 'main-check-block': true, disabled: !hasAccessToFlCheck }">
                    <img src="/images/proverka-fl.svg" class="main-check-block__icon">
                    <div class="main-check-block__text">Проверка ФЛ</div>
                    <img src="/images/arrow-right.svg" class="main-check-block__arrow"/>
                </a> -->
                <a :href="hasAccessToVisitorCheck ? '/visitor-fl-check' : '#'" :class="{'main-check-block': true, disabled: !hasAccessToVisitorCheck }">
                    <img src="/images/proverka-posetitela.svg" class="main-check-block__icon">
                    <div class="main-check-block__text">Онлайн-проверка ФЛ</div>
                    <img src="/images/arrow-right.svg" class="main-check-block__arrow"/>
                </a>
                <a :href="hasAccessToAdditionalCheck ? '/additional-check' : '#'" :class="{'main-check-block': true, disabled: !hasAccessToAdditionalCheck }">
                    <img src="/images/dop-proverka.svg" class="main-check-block__icon">
                    <div class="main-check-block__text">Оффлайн-проверка</div>
                    <img src="/images/arrow-right.svg" class="main-check-block__arrow"/>
                </a>
            </div>
        </div>

        <div id="screen-fast_search" style="padding-bottom: 20px; display: block;" v-show="showModal">
            <div class="cross" @click="showModal = false">
                <i class="icon-close lnr lnr-cross"></i>
            </div>

            <div class="section-inner l-centered">
                <div class="search-request-modal" style="border-radius: 8px; border-color: #98bdd4">
                    <div @click="findHandler" class="search-request-modal-submit" style="line-height: 64px;"><i class="lnr lnr-magnifier"></i></div>
                    <div class="search-request-modal-erase" v-if="input" @click="input = ''" style="display: block;"><i class="lnr lnr-cross"></i></div>
                    <div class="search-request-modal-holder">
                        <input @keydown.13="findHandler" v-model="input" type="text" placeholder="ИНН, ОГРН, ОКПО, название или ФИО" id="search-request-modal" autocomplete="off">
                    </div>
                </div>

                <div style="z-index: 2; margin-top: 10px;">
                    <div style="text-align: center; font-size: 12px;">
                        <button class="dashed search-help-modal-toggle" @click="toggleHelpCard">
                            Помощь <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div style="text-align: center; margin-top: 10px;">
                        <div v-show="showHelp" class="search-help-modal" style=" margin: 0 auto; border: solid 1px #ccc; background: #eee; border-radius: 6px; padding: 15px; max-width: 30em; font-size: 14px; display: none; text-align: left;">
                            <span style="display: inline-block; font-size: 16px; margin-bottom: 5px;">Поиск может осуществляться по следующим параметрам в любых сочетаниях:</span>
                            <span style="display: inline-block; font-weight: 700;">Для поиска юридических лиц</span>
                            <span style="display: inline-block; margin-bottom: 5px;">ИНН, ОГРН, ОКПО, краткое или полное название ЮЛ, ФИО руководителя ЮЛ (частично или полностью), ФИО совладельца ЮЛ (частично или полностью).</span>
                            <span style="display: inline-block; font-weight: 700;">Для поиска физических лиц и ИП</span>
                            <span style="display: inline-block; margin-bottom: 5px;">ИНН ФЛ, ОГРНИП, ФИО ИП/руководителя ЮЛ/совладельца ЮЛ (частично или полностью).</span>
                            <span style="display: inline-block;">Для поиска точного совпадения необходимо использовать кавычки " ". Например, "НУРАЛИЕВ БОРИС ГЕОРГИЕВИЧ", "ИНВЕСТ СТРОЙ ГРУПП"</span>
                        </div>
                    </div>
                </div>

                <div id="extended-modal-result" style="display: none; padding-top: 30px;">
                    Найдено больше 12 ЮЛ. Пожалуйста уточните запрос
                </div>

                <ul id="search-modal-result" style="padding: 30px 0 0 0; font-weight: 400"></ul>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return {
            search: [],
            input: '',
            inputTimeout: null,
            showModal: false,
            showHelp: false,
            raw: false
        }
    },
    computed: {
        auth(){
            return window.auth
        },
        hasAccessToUlCheck() {
            return this.$store.state.user.groups ? this.$store.state.user.groups.filter(e => e.rules.check_ul || e.rules.adm_check_ul).length : false
        },
        hasAccessToFlCheck() {
            return this.$store.state.user.groups ? this.$store.state.user.groups.filter(e => e.rules.check_fl || e.rules.adm_check_fl).length : false
        },
        hasAccessToAdditionalCheck() {
            return this.$store.state.user.groups ? this.$store.state.user.groups.filter(e => e.rules.additional_fl || e.rules.adm_additional_fl).length : false
        },
        hasAccessToVisitorCheck() {
            return this.$store.state.user.groups ? this.$store.state.user.groups.filter(e => e.rules.check_visitor || e.rules.adm_check_visitor).length : false
        },
        searchLength() { return this.search?.length },
    },
    methods: {
        openSelected(){
            const searchItems = this.$refs['search-items']
            if(searchItems) {
                const selectedSearchItem = searchItems.filter(e => e.getAttribute('data-selected'))
                if(selectedSearchItem && selectedSearchItem.length) {
                    const ogrn = searchItems.filter(e => e.getAttribute('data-selected'))[0].getAttribute('data-ogrn')
                    if(ogrn) {
                        window.open(`${window.location}/company/${ogrn}`)
                    }
                }
            }
        },
        arrowHandler(e){
            const searchItems = this.$refs['search-items']
            const setAttrAtIndex = indx => indx >= 0 && indx <= 9 ? searchItems[indx].setAttribute('data-selected', 'true') : false

            if(searchItems && searchItems.length) {
                const selectedSearchItem = searchItems.filter(e => e.getAttribute('data-selected'))
                if(selectedSearchItem.length) {
                    const selectedItemIndex = searchItems.map(e => e.hasAttribute('data-selected')).indexOf(true)
                    if(selectedItemIndex >= 0 && selectedItemIndex <= 9) {
                        searchItems.map(e => e.removeAttribute('data-selected'))
                        if(e.keyCode == 40) {
                            setAttrAtIndex(selectedItemIndex + 1)
                        } else if(e.keyCode == 38) {
                            setAttrAtIndex(selectedItemIndex - 1)
                        }
                    }
                } else {
                    setAttrAtIndex(0)
                }
            }
        },
        findHandler(){
            axios({
                method: "POST",
                url: `${window.api_pro}search/company?limit=100&offset=0&demo=1`,
                headers: {
                    "Authorization": "Bearer " + window.apiSession,
                    "Cid": window.cid
                },
                data: {
                    request: this.input,
                    search_types: {
                        raw: this.raw
                    },
                    uchr: "no"
                }
            }).then(e => {
                console.log('E', e)
                if(e.data.data && e.data.data.length){
                    if(e.data.data.length == 1) {
                        $("body").html("<div style='padding: 100px; text-align: center; font-size: 20px;'>Карточка загружается</div>")
                        if (e.data.data[0].rec_type == 1) {
                            window.location = "/company/" + e.data.data[0].ogrn
                        }
                        if (e.data.data[0].rec_type == 2) {
                            window.location = "/person/" + e.data.data[0].ogrn
                        }
                    }
                    this.renderFastSearch(e.data.data)
                } else {
                    this.$store.dispatch('showErrorPopUp', "По заданным условиям поиска данных не найдено")
                }
            }).catch(err => {
                console.log(err)
            })
        },
        renderFastSearch(result){

            // $("#extended-result").hide();
            // $("#extended-result-2").hide();

            // if (result.length >= 12) {
            //     $("#extended-count").text(" более 12 результатов");
            //     $("#extended-result").show();

            //     $("#extended-count-2").text(" более 12 результатов");
            //     $("#extended-result-2").show();
            // }

            var html = "";

            for (var i in result) {
                if (i >= 12) break;
                console.log("I", i)
                var row = result[i];

                if (row.addr_full) {
                    row.addr_full = row.addr_full.replace("ДОМ ДОМ", "ДОМ");
                    row.addr_full = row.addr_full.replace("КОРП КОРПУС", "КОРПУС");
                    row.addr_full = row.addr_full.replace("КВ КВАРТИРА", "КВАРТИРА");
                }

                var status = "";
                var company_status = '0'; //По умолчанию, компания действующая
                if( row.rec_status[0] ){
                    company_status = window.helpers.check_company_status(row.rec_status[0]).toString();
                }else{
                    if( row.date_stop ){
                        company_status = '1';
                    }
                }

                switch(row.status_type[0]) {
                    case 1:
                        if (row.rec_type == 1) {
                            status = '<span style="color:#37AE26;"><i class="lnr lnr-checkmark-circle"></i> Действующее предприятие,</span> зарегистрировано ' + row.date_start + '';
                        }else if (row.rec_type == 2) {
                            status = '<span style="color:#37AE26;"><i class="lnr lnr-checkmark-circle"></i> Действующий ИП,</span> зарегистрирован ' + row.date_start + '';
                        }
                        break;
                    case 0:
                        if (row.rec_type == 1) {
                            status = '<span style="color:#cc0000;"><i class="lnr lnr-cross-circle"></i> Ликвидированное предприятие,</span> зарегистрировано ' + row.date_start + (row.date_stop ? ', ликвидировано '+ row.date_stop : '');
                        }else if (row.rec_type == 2) {
                            status = '<span style="color:#cc0000;"><i class="lnr lnr-cross-circle"></i> Ликвидированный ИП,</span> зарегистрирован ' + row.date_start + (row.date_stop ? ', прекратил деятельность '+ row.date_stop : '');
                        }
                        break;
                    case 2:
                        if (row.rec_type == 1) {
                            status = '<span style="color:#cc0000;"><i class="lnr lnr-cross-circle"></i> Предприятие в стадии ликвидации,</span> зарегистрировано ' + row.date_start + '';
                        }else if (row.rec_type == 2) {
                            status = '<span style="color:#cc0000;"><i class="lnr lnr-cross-circle"></i> ИП в стадии ликвидации,</span> зарегистрирован ' + row.date_start + '';
                        }
                        break;
                }

                var name = row.name_short ? (row.name_short.length > 3 ? row.name_short : row.name_full) : row.name_full;

                html += '<li>';
                if (row.rec_type == 1) html += '<h4><a href="/company/'+row.ogrn+'" target="_blank">' + name + '</a></h4>';
                if (row.rec_type == 2) html += '<h4><a href="/person/'+row.ogrn+'" target="_blank">' + name + '</a></h4>';
                html += '<p>'+status+'</p>';

                if (row.name_short && row.name_full) {
                    html += "<p><b>Полное наименование</b>: "+row.name_full+"</p>";
                }

                var codes = "";
                if (row.ogrn) codes += '<span style="white-space:nowrap;">ОГРН ' + row.ogrn + '</span>, ';
                if (row.inn) codes += '<span style="white-space:nowrap;">ИНН ' + row.inn + '</span>, ';
                if (row.okpo) codes += '<span style="white-space:nowrap;">ОКПО ' + row.okpo + '</span>, ';
                if (row.kpp) codes += '<span style="white-space:nowrap;">КПП ' + row.kpp + '</span>, ';
                codes = codes.substring(0,codes.length-2);
                if (codes) html += '<p>' + codes  + '</p>';

                var header = ""
                if (row.rec_type == 1) {
                    if (row.headers && row.headers.length) header = row.headers[row.headers.length-1];

                    for (let i in row.stakeholders) {
                        var stakeholder = row.stakeholders[i];
                        if (stakeholder.type == 1) {
                            var position = "Руководитель";
                            var inn = "";
                            if (stakeholder.position) position = stakeholder.position;
                            if (stakeholder.inn) inn = ', <span style="white-space: nowrap;">ИНН ' + stakeholder.inn + '</span>';
                            header = '<b>' + position + ':</b> ' + stakeholder.name + inn;
                        }
                    }
                }
                html += '<p>' + header  + '</p>';

                if (row.stakeholders && row.stakeholders.filter(function(e){ return e.type == 2 || e.share }).length) {
                    var stakeholders = row.stakeholders.filter(function(e){ return e.type == 2 || e.share }).map(function(stakeholder, index){
                        if(stakeholder.name && index < 3) {
                            return stakeholder.name + (stakeholder.inn ? (" ИНН: " + stakeholder.inn) : "") + "; "
                        } else if(stakeholder.name && index == 3) {
                            return stakeholder.name + (stakeholder.inn ? (" ИНН: " + stakeholder.inn) : "") + "..."
                        }
                    }).join('')
                    html += "<p><b>Собственники: </b>" + stakeholders + "</p>"
                }

                if (row.address != "") html += '<p><b>Адрес: </b>' + row.address + '</p>';
                html += '</li>';
            }

            window.searchMain.filterData.request = window.searchMain.filterData.request.replace(/\./ig, "");

            let r = window.searchMain.filterData.request.split(" ");
            for (let i in r) r[i] = r[i].replace(/"/g,'');
            for (let i in r) {
                r[i] == r[i].trim();
                if (r[i]) if (r[i].length > 1) html = html.replace(new RegExp(r[i], 'ig'), '[l]$&[/l]');
            }

            html = html.replace(/company\/\[l\](.*?)\[\/l\]/gi, 'company/$1');
            html = html.replace(/person\/\[l\](.*?)\[\/l\]/gi, 'person/$1');
            html = html.replace(/\[l\](.*?)\[\/l\]/gi, '<span style="background:rgba(245,215,110,0.4);">$1</span>');

            if (result.length == 0) html = '<div style="text-align: center; font-size: 40px; font-family:\'PT Serif\', serif;">Ничего не найдено</div>';

            // console.log("HTML", html)

            if(result.length >= 12) {
                $("#extended-modal-result").show()
            } else {
                $("#extended-modal-result").hide()
            }

            $("#search-modal-result").html(html)

            this.showModal = true
            this.search = []
        },
        clickSearchItem(ogrn) {
            this.redirectBlank(`/company/${ogrn}`)
            this.search = []
        },
        resetSearch(){
            this.input = ''
            this.search = []
        },
        timeoutRequest(evt) {
            if(this.inputTimeout) {
                clearTimeout(this.inputTimeout)
            }

            this.inputTimeout = setTimeout(this.searchHandle, 500)
        },
        searchHandle() {
            if(this.input) {
                axios({
                    method: "POST",
                    url: "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Token c7e6720adc39e28edd06107e1d23e45fb6c27f8e"
                    },
                    data: { query: this.input }
                    }).then(e => {
                        this.search = e.data.suggestions
                            .filter(function(elmnt){ return (elmnt.data?.inn?.[0] ? elmnt.data?.inn?.[0] : 0) + (elmnt.data?.inn?.[1] ? elmnt.data?.inn?.[1] : 0) != '99' })
                            .filter((e,i) => i < 10)
                            .map(e => ({value: e.value, management: e.data.management, ogrn: e.data.ogrn}))
                    }).catch(e => {
                        console.error('err', e.message)
                })
            } else {
                this.search = []
            }
        },
        toggleHelpCard() { this.showHelp = !this.showHelp }
    },
    watch: {
        search(){
            if(this.$refs['search-items'] && this.$refs['search-items'].length) {
                this.$refs['search-items'].map(e => e.removeAttribute('data-selected'))
            }
        }
    },
    mounted() { console.log(this.$store.state.user, 'USER') }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

$bdra: 5px

@mixin bd-radius-shadow
    border-radius: $bdra
    box-shadow: 0 0 10px rgba(0,0,0, 0.25)

$check-ul-height: 290px
$input-width: 88%

.search-help-modal-toggle
    border: none
    background: none

#screen-fast_search
    max-height: calc( 100vh - 170px ) !important
    overflow-y: auto !important

.main__login
    background-image: url('/images/rosseti-main.jpg')
    background-size: cover
    background-repeat: no-repeat
    background-position: center
main
    min-height: calc(100% - (#{$header-height} + #{$footer-height / 2}))
    font-family: $ff

main
    padding-top: $margin-top-from-header
    padding-bottom: 50px
    .main-check-ul
        background: url('/images/banner.svg') #E6EEF2
        background-size: cover
        background-repeat: no-repeat
        background-position: center
        height: $check-ul-height
        width: 100%
        margin-top: 50px
        border-radius: 5px
        position: relative
        h2
            text-align: center
            padding-top: 110px
            font-size: 28px
            font-weight: 500
        &__search
            position: absolute
            bottom: 0
            left: 0
            width: 100%
            padding: 20px
            // padding: 20px 20px 40px
            @include clearfix
            .lnr.lnr-cross
                cursor: pointer
                position: absolute
                right: 180px
                font-size: 26px
                bottom: 30px
            &-results
                position: absolute
                top: $check-ul-height
                left: 0
                margin: 0
                width: calc(90% - (20px * 2))
                padding: 0 20px
                background-color: rgba(#E4EFF2, 0.95)
                border-bottom-right-radius: $bdra
                border-bottom-left-radius: $bdra
                z-index: 1
                > div
                    cursor: pointer
                    padding: 5px 20px
                    &:not(:last-child)
                        border-bottom: 1px solid #ccc
                    &:hover
                        color: $link-blue-color
                    &[data-selected="true"]
                        background-color: rgba(lightblue, 0.8)
            input[type="text"], button
                @include bd-radius-shadow
                display: inline-block
                vertical-align: middle
            input[type="text"]
                height: 40px
                width: 88%
                padding: 10px
                border: 0
                float: left
            button
                cursor: pointer
                float: right
                height: 42px
                width: 10%
                background-color: #005B9B
                color: #ffffff
                border: 0
                font-size: 16px
                font-weight: 500
                font-family: $ff
            label
                display: block
                position: absolute
                bottom: 10px
                left: 0
                padding-left: 20px
                cursor: pointer
    .main-separator
        width: 100%
        height: 2px
        background-color: #E6EEF2
        margin: 20px auto
        border-radius: 3px
    .main-check
        display: flex
        justify-content: space-evenly
        text-align: center
        &-block
            @include bd-radius-shadow
            @include clearfix
            margin: 10px
            display: inline-block
            vertical-align: top
            width: 30%
            font-size: 18px
            background-color: #fff
            padding: 0 15px
            font-weight: 400
            cursor: pointer
            transition: all .1s linear
            position: relative
            line-height: 65px
            &:hover
                background-color: #E6EEF1
            &__text, &__icon, &__arrow
                display: block
                text-align: center
                vertical-align: middle
            &__arrow
                // width: 30px
                // height: auto
                // position: absolute
                // right: 20px
                // top: 18px
                display: none
            &__icon
                width: 150px
                margin: 20px auto 0
                display: block
            &__text
                font-size: 20px
                line-height: 40px
                margin-bottom: 10px
                font-weight: 500

.main-check-block.disabled
    cursor: not-allowed
    background-color: #E6EEF1
    color: #555
    &:hover
        color: #555

.main-check-ul__search
    input[disabled="disabled"]
        cursor: not-allowed
        background-color: #E6EEF1
</style>